import { forwardRef } from 'react';
import { DefaultMeta } from '../../../../types/partner-page-types';
import { If } from '../../../Atoms/Conditionals';
import { IPageSection } from '../../types';
import { ExcitingOffers } from './exciting_offers';
import { PartnerRewards } from './partner-rewards';

export const RewardsSection: React.FC<IPageSection> = forwardRef(
  (
    { id, metaData, postData },
    ref: React.ForwardedRef<HTMLDivElement>
  ): JSX.Element => {
    const rewardData = metaData?.reward_data;
    const showOffers = rewardData?.data.length && rewardData?.data.length >= 1;
    console.log(postData?.collection, 'postData?.collection');

    return (
      <div data-testid={id} id={id} ref={ref}>
        <If
          condition={
            !!metaData && !!showOffers && postData?.collection !== 'bfsi'
          }
        >
          <ExcitingOffers metaData={metaData as DefaultMeta} />
        </If>
        <If condition={!!postData?.collection}>
          <PartnerRewards />
        </If>
      </div>
    );
  }
);
RewardsSection.displayName = 'RewardsSection';
